import {
  InsuredObjectsOutput,
  PackObjects,
  RunPetisSimulationClientResponse,
} from '../../@types/RunPetisSimulation'
import { useAnimalStore } from '../../Stores/animalStore'
import { useSimulatorStore } from '../../Stores/simulatorStore'
import { useRunPetisSimulationStore } from '../../Stores/useRunPetisSimulationStore'
import { AnimalsSecured } from '../../Types/AnimalStore'

type PrepareAnimalToRecalculateProps = {
  animal: AnimalsSecured
  coverageId: string
  value: boolean
}

export const usePrepareAnimalToRecalculate = () => {
  const { updateAnimal } = useAnimalStore()
  const { setHasRecalculate } = useSimulatorStore()
  const { runPetisSimulation, setRunPetisSimulation } =
    useRunPetisSimulationStore()

  const updateSimulationCoverage = (
    petisSimulation: RunPetisSimulationClientResponse | null,
    animalId: string,
    packId: string,
    coverageId: string,
    value: boolean,
  ) => {
    const updatedPetisSimulation = { ...petisSimulation }
    const { runPetisSimulationResponse } = updatedPetisSimulation

    if (runPetisSimulationResponse?.insuredObjectGroup?.insuredObjects) {
      runPetisSimulationResponse.insuredObjectGroup.insuredObjects =
        runPetisSimulationResponse?.insuredObjectGroup?.insuredObjects?.map(
          (insuredObject) =>
            updateInsuredObject(
              insuredObject,
              animalId,
              packId,
              coverageId,
              value,
            ),
        )
    }

    return updatedPetisSimulation
  }

  const updateInsuredObject = (
    insuredObject: InsuredObjectsOutput,
    animalId: string,
    packId: string,
    coverageId: string,
    value: boolean,
  ) => {
    if (animalId.toString() === insuredObject?.insuredObjectId) {
      const { packsObject } = insuredObject

      if (packsObject?.packs) {
        packsObject.packs = packsObject?.packs?.map((pack) =>
          updatePack(pack, packId, coverageId, value),
        )
      }
    }

    return insuredObject
  }

  const updatePack = (
    pack: PackObjects,
    packId: string,
    coverageId: string,
    value: boolean,
  ) => {
    if (pack.packId === packId) {
      pack.coverages = pack?.coverages?.map((coverage) => {
        if (coverage?.coverageId === coverageId) {
          coverage.isPreSelected = value
        }

        return coverage
      })
    }

    return pack
  }

  const handleUpdateAnimalToRecalculate = ({
    animal,
    coverageId,
    value,
  }: PrepareAnimalToRecalculateProps) => {
    const updatedRunPetisSimulation = updateSimulationCoverage(
      runPetisSimulation,
      animal.id,
      animal.pack?.packId!,
      coverageId,
      value,
    )

    const pack = {
      ...animal?.pack,
      coverages: animal?.pack?.coverages?.map((coverage) => {
        if (coverage.coverageId === coverageId) {
          return {
            ...coverage,
            isPreSelected: value,
          }
        }

        return coverage
      }),
    }

    setRunPetisSimulation(updatedRunPetisSimulation)

    updateAnimal({ pack: pack as never }, animal?.id as never)
    setHasRecalculate(
      `animal-${animal?.id}-${animal?.pack?.packId}`,
      coverageId,
    )
  }

  return {
    handleUpdateAnimalToRecalculate,
  }
}
